export * from './lib/bff-customer-web-shared-core.module';
